import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  tableCellClasses,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Paper,
  Tooltip,
  Dialog,
  InputAdornment,
} from "@mui/material";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { CheckIcon, FontFamily, PendingIcon, SearchIcon } from "assets";
import InputField from "components/Input";

import ClientServices from "services/Client";
import SystemServices from "services/System";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { makeStyles } from "@mui/styles";
import styled from "@emotion/styled";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  CommaSeparator,
  formatPermissionData,
  handleExportWithComponent,
} from "utils";
import { PDFExport } from "@progress/kendo-react-pdf";
import WhatsAppModal from "../VehicleBooking/WhatsApp.modal";
import EmailModal from "../VehicleBooking/Email.modal";
import Pagination from "components/Pagination";
import SimpleDialog from "components/Dialog/SimpleDialog";
import DatePicker from "components/DatePicker";
import DropdownMenu from "components/DropDown";
import { useAuth } from "context/UseContext";
// *For Table Style

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "normal",
    verticalAlign: "top",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    // textWrap: "nowrap",
    verticalAlign: "middle",
    whiteSpace: "normal",
    maxWidth: "200px",
    wordBreak: "break-word",
    padding: "3px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "3px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "5px",
      width: "24px",
      height: "24px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function UnpaidPaidInvoicesV2() {
  const classes = useStyles();
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const { user } = useAuth();
  const tableHead = [
    "CUSTOMER",
    "INV. #",
    "PURCHASED",
    "MAKE/MODEL/COLOR",
    "LOT",
    "VIN",
    "DESTINATION",
    "PAID AMOUNT",
    "DISCOUNT",
    "WAR SUR.CHAR DISC",
    "NET DUE",
    "STATUS",
    "ACTION",
  ];

  // *For Client Dropdown
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectCostingId, setSelectCostingId] = useState(false);
  const [checkedItems, setCheckedItems] = useState({
    shipping: false,
    storage: false,
    custom_vat: false,
  });
  const [openReverseModal, setOpenReverseModal] = useState(false);
  const [selectedRefId, setSelectedRefId] = useState(0);
  const [activeMenu, setActiveMenu] = useState(null);
  const [permissions, setPermissions] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reverseData, setReverseData] = useState({ notes: "" });

  const handleDelete = async () => {
    try {
      let data = await ClientServices.deleteCostingEntries({
        costing_id: selectCostingId,
        ...checkedItems,
      });
      setOpenDeleteModal(false);
      SuccessToaster(data?.message);
      setCheckedItems({
        shipping: false,
        storage: false,
        custom_vat: false,
      });
      navigate("/unpaid-paid-invoices-v2");
    } catch (error) {
      ErrorToaster(error || error.message || "An error occurred");
      setOpenDeleteModal(false);
    }
  };

  const handleReverse = async () => {
    try {
      const obj = {
        invoice_id: selectedRefId,
        reverse_date: selectedDate ? new Date(selectedDate) : new Date(),
        reversed_note: reverseData.notes,
      };

      let data = await ClientServices.reverseCostingEntries(obj);
      setOpenReverseModal(false);
      SuccessToaster(data?.message);
      navigate("/unpaid-paid-invoices-v2");
    } catch (error) {
      ErrorToaster(error.message || error.message || "An error occurred");
    }
  };

  const handleChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  // *For Paid Status
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [destinations, setDestinations] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [openWhatsAppModal, setOpenWhatsAppModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  //* ForLoader
  const [loader, setLoader] = useState(false);

  // *For Filters
  const [filters, setFilters] = useState({});

  const [invoices, setInvoices] = useState();

  // *For Tooltip
  const [copied, setCopied] = useState(false);
  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const copyContent = (text) => {
    const contentToCopy = text;
    navigator.clipboard.writeText(contentToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 300);
  };

  // *For Vendor Costing
  const getInvoices = async (page, limit, filter) => {
    setLoader(true);
    const Page = page ? page : currentPage;
    const Limit = limit ? limit : pageLimit;
    const Filter = { ...filters, ...filter };
    setCurrentPage(Page);
    setPageLimit(Limit);

    try {
      let params = {
        page: Page,
        limit: Limit,
        invoiceReq: true,
        customer_id: selectedClient?.id,
      };
      params = { ...params, ...Filter };
      const { data } = await ClientServices.getClientCostingV2(params);
      setPermissions(formatPermissionData(data?.permissions));
      // Filter out records where discount, total, and subtotal are all zero
      const filteredRows = data?.costings?.rows?.filter(
        (row) =>
          row.invoice !== null &&
          (parseFloat(row.discount) !== 0 ||
            parseFloat(row.total) !== 0 ||
            parseFloat(row.subtotal) !== 0),
      );

      setTotalCount(data?.costings?.count);
      setInvoices(data?.costings?.rows);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  // *For Apply Filters
  const applyFilter = async () => {
    try {
      let data = {
        customer_id: selectedClient?.id,
        // vin: getValues('vin'),
        // lot: getValues('lot'),
        search: getValues("search"),
        status: selectedStatus?.id,
        destination_id: selectedDestination?.id,
      };

      getInvoices(1, "", data);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  // *For Clients
  const getClientDropdown = async () => {
    try {
      const { data } = await ClientServices.getClientDropdown();

      setClients(data?.customers?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Destinations (Destination filter options)
  const getDestinations = async (search) => {
    try {
      const { data } = await SystemServices.getDestinations({
        page: 1,
        limit: 200,
        search: search,
      });
      setDestinations(data?.destinations?.rows ?? []);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const downloadExcel = async () => {
    const headers = tableHead.filter((item) => item !== "Action");
    const rows = invoices?.map((item) => [
      `GSI-${item?.invoice?.id ?? "-"}`,
      item?.booking?.purchase_date
        ? moment(item?.booking?.purchase_date).format("DD-MM-YYYY")
        : "N/A",
      item?.booking?.veh_model?.name ?? "-",
      item?.booking?.veh_make?.name ?? "-",
      item?.booking?.lot_number ?? "-",
      item?.booking?.vin ?? "-",
      item?.shipping?.dest?.name ?? "-",
      item?.booking?.color ?? "-",
      parseFloat(item?.subtotal).toFixed(2) ?? "-",
      parseFloat(item?.discount).toFixed(2) ?? "-",
      parseFloat(item?.war_surcharge_disc || 0).toFixed(2) ?? "-",
      parseFloat(item?.total).toFixed(2) ?? "-",
      item?.invoice && item?.invoice?.paid == 0
        ? "Unpaid"
        : item?.invoice &&
            item?.invoice?.paid > 0 &&
            item?.invoice?.paid < item?.invoice?.total
          ? "Partial"
          : "Paid",
    ]);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    worksheet.addRow(headers);
    rows.forEach((r) => worksheet.addRow(r));

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "data.xlsx");
  };
  useEffect(() => {
    getClientDropdown();
    getDestinations();
    // getInvoices();
  }, []);

  const handleCloseWhatsAppModal = () => {
    setOpenWhatsAppModal(false);
    setSelectedId(null);
  };
  const handleCloseEmailModal = () => {
    setOpenEmailModal(false);
    setSelectedId(null);
  };
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null); // Toggle the active menu
  };
  return (
    <Fragment>
      <SimpleDialog
        open={openReverseModal}
        onClose={() => setOpenReverseModal(false)}
        title={"Reverse to Shipping Wallet"}
      >
        <Box>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12}>
              <DatePicker
                size={"small"}
                label={"Select Date"}
                value={
                  selectedDate ? moment(selectedDate).toDate() : new Date()
                }
                onChange={(date) =>
                  setSelectedDate(moment(date).format("YYYY-MM-DD"))
                }
              />
              <InputField
                size={"small"}
                label={"Enter Notes"}
                placeholder={"notes"}
                onInput={(e) => {
                  setReverseData((d) => ({ ...d, notes: e.target.value }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
              <PrimaryButton
                loading={loading}
                style={{ marginRight: "5px" }}
                onClick={() => handleReverse()}
                title="Reverse"
                type="submit"
              />
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>

      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Typography
          sx={{
            p: 3,
            px: 5,
            fontSize: 17,
            fontFamily: FontFamily.openSans,
            fontWeight: "bold",
          }}
          id="alert-dialog-title"
        >
          {"Are You Sure You Want To Delete Paid Shipping Invoice?"}
        </Typography>

        <Grid item xs={12} sm={12} sx={{ mb: 2, textAlign: "center" }}>
          <PrimaryButton
            title="No"
            type="submit"
            buttonStyle={{ minWidth: "120px" }}
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          />
          <Box component={"span"} sx={{ mx: 1 }} />
          <PrimaryButton
            title="Yes"
            type="button"
            buttonStyle={{
              minWidth: "120px",
              bgcolor: Colors.danger,
              "&:hover": { bgcolor: Colors.danger },
            }}
            bgcolor={Colors?.danger}
            onClick={() => {
              handleDelete();
            }}
          />
        </Grid>
      </Dialog>
      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Paid/Unpaid Shipping Invoices V2
            </Typography>
            {invoices?.length > 0 && (
              <Box
                sx={{
                  textAlign: "right",
                  p: 4,
                  display: "flex",
                  gap: 2,
                }}
              >
                <PrimaryButton
                  title="Download PDF"
                  type="button"
                  style={{ backgroundColor: Colors.bluishCyan }}
                  onClick={() => handleExportWithComponent(contentRef)}
                />
                <PrimaryButton
                  title={"Download Excel"}
                  onClick={() => downloadExcel()}
                />
              </Box>
            )}
          </Box>
        </Grid>
        <Grid
          item
          md={11}
          component={"form"}
          onSubmit={handleSubmit(applyFilter)}
        >
          <Box
            sx={{
              m: "10px 0 10px 0",
              // p: '20px',
              // bgcolor: Colors.feta,
              // border: `1px solid ${Colors.iron}`,
              // borderRadius: '9px',
            }}
          >
            <Grid container spacing={1} alignItems={"center"}>
              <Grid item xs={6} md={2.5} sm={3}>
                <InputField
                  size={"small"}
                  label={"Search"}
                  placeholder={"Search"}
                  inputStyle={{ backgroundColor: "#f5f5f5" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  register={register("search", {
                    // onChange: (e) => handleFilter({ search: e.target.value }),
                  })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      applyFilter();
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} md={2.5} sm={3}>
                <SelectField
                  size="small"
                  label={"Client"}
                  options={clients}
                  selected={selectedClient}
                  onSelect={(value) => {
                    setSelectedClient(value);
                  }}
                  error={errors?.client?.message}
                  register={register("client")}
                />
              </Grid>

              <Grid item xs={6} md={2.5} sm={3}>
                <SelectField
                  size="small"
                  label={"Status"}
                  options={[
                    { id: true, name: "Paid" },
                    { id: false, name: "Unpaid" },
                  ]}
                  selected={selectedStatus}
                  onSelect={(value) => setSelectedStatus(value)}
                  error={errors?.status?.message}
                  register={register("status")}
                />
              </Grid>

              <Grid item xs={6} md={2.5} sm={3}>
                <SelectField
                  size="small"
                  label={"Destination"}
                  options={destinations}
                  selected={selectedDestination}
                  onSelect={(value) => setSelectedDestination(value)}
                  onSearch={(v) => getDestinations(v)}
                  register={register("destination")}
                />
              </Grid>
              {/* <Grid item xs={12} md={2.5}>
                <InputField
                  size={'small'}
                  label={'Vin#'}
                  placeholder={'Vin'}
                  register={register('vin')}
                />
              </Grid>
              <Grid item xs={12} md={2.5}>
                <InputField
                  size={'small'}
                  label={'Lot#'}
                  placeholder={'Lot'}
                  register={register('lot')}
                />
              </Grid> */}

              <Grid item xs={12} md={2}>
                <Box
                  sx={{
                    mt: "12px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <PrimaryButton type="submit" title="Search" />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid item md={11}>
          <Box>
            <PDFExport
              ref={contentRef}
              landscape={true}
              paperSize="A4"
              margin={5}
              fileName="Paid/Unpaid Shipping Invoices"
            >
              <Box className="pdf-show" sx={{ display: "none" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.NunitoRegular,
                      mb: 2,
                    }}
                  >
                    Paid/Unpaid Shipping Invoices
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: 400,
                      fontSize: "12px",
                      mt: 1.5,
                      color: Colors.charcoalGrey,
                    }}
                  >
                    <span>Date: &nbsp;&nbsp;</span>
                    {moment().format("MM-DD-YYYY")}
                  </Box>
                </Box>
              </Box>
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                  borderRadius: 2,
                  maxWidth: "calc(100vw - 330px)",
                  // maxHeight: 'calc(94vh - 330px) ',
                  height:
                    invoices?.length < 2
                      ? "calc(100vh - 630px)"
                      : "calc(100vh - 330px)",
                }}
                className="table-box"
              >
                <Table stickyHeader sx={{ minWidth: 500 }}>
                  <TableHead>
                    <Row>
                      {tableHead.map((cell, index) => (
                        <Cell className="pdf-table" key={index}>
                          {cell}
                        </Cell>
                      ))}
                    </Row>
                  </TableHead>
                  <TableBody>
                    {!loader ? (
                      invoices?.length > 0 ? (
                        <>
                          <Fragment>
                            {invoices?.map((item, index) => (
                              <Row
                                key={index}
                                sx={{
                                  bgcolor: index % 2 !== 0 && "#EFF8E7",
                                }}
                              >
                                <Cell className="pdf-table">
                                  {(() => {
                                    const customerName =
                                      item?.booking?.customer?.name ?? "-";
                                    const shouldWrap = customerName.length > 19;

                                    return (
                                      <Box
                                        sx={{
                                          whiteSpace: shouldWrap
                                            ? "normal"
                                            : "nowrap",
                                          wordBreak: shouldWrap
                                            ? "break-word"
                                            : "unset",
                                          maxWidth: "200px",
                                          mx: "auto",
                                        }}
                                      >
                                        {customerName}
                                      </Box>
                                    );
                                  })()}
                                </Cell>
                                <Cell className="pdf-table">
                                  GSI-{item?.invoice?.id ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {" "}
                                  {item?.booking?.purchase_date
                                    ? moment(
                                        item?.booking?.purchase_date,
                                      ).format("DD-MM-YYYY")
                                    : "N/A"}
                                </Cell>
                                <Cell className="pdf-table">
                                  <Tooltip
                                    title={[
                                      item?.booking?.veh_make?.name,
                                      item?.booking?.veh_model?.name,
                                      item?.booking?.color,
                                    ]
                                      .filter(Boolean)
                                      .join("-")}
                                    arrow
                                  >
                                    <span>
                                      {[
                                        item?.booking?.veh_make?.name,
                                        item?.booking?.veh_model?.name,
                                        item?.booking?.color,
                                      ]
                                        .filter(Boolean)
                                        .join("-")}
                                    </span>
                                  </Tooltip>
                                </Cell>

                                <Cell className="pdf-table">
                                  <Tooltip
                                    className="pdf-hide"
                                    title={
                                      copied
                                        ? "copied"
                                        : (item?.booking?.lot_number ?? "-")
                                    }
                                    arrow
                                    placement="top"
                                    slotProps={{
                                      popper: {
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [10, -2],
                                            },
                                          },
                                        ],
                                      },
                                    }}
                                    onClick={() =>
                                      copyContent(
                                        item?.booking?.lot_number ?? "-",
                                      )
                                    }
                                  >
                                    <span>{item?.booking?.lot_number}</span>
                                  </Tooltip>
                                  <Box
                                    component={"div"}
                                    className="pdf-show"
                                    sx={{ display: "none !important" }}
                                  >
                                    {item?.booking?.lot_number ?? "-"}
                                  </Box>
                                </Cell>
                                <Cell className="pdf-table">
                                  <Tooltip
                                    className="pdf-hide"
                                    title={
                                      copied
                                        ? "copied"
                                        : (item?.booking?.vin ?? "-")
                                    }
                                    arrow
                                    placement="top"
                                    slotProps={{
                                      popper: {
                                        modifiers: [
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [10, -2],
                                            },
                                          },
                                        ],
                                      },
                                    }}
                                    onClick={() =>
                                      copyContent(item?.booking?.vin ?? "-")
                                    }
                                  >
                                    <span>{item?.booking?.vin}</span>
                                  </Tooltip>
                                  <Box
                                    component={"div"}
                                    className="pdf-show"
                                    sx={{ display: "none !important" }}
                                  >
                                    {item?.booking?.vin ?? "-"}
                                  </Box>
                                </Cell>

                                <Cell className="pdf-table">
                                  {item?.shipping?.dest?.name ?? "-"}
                                </Cell>

                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(
                                      item?.invoice?.paid || 0,
                                    ).toFixed(2),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(item?.discount).toFixed(2),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(
                                      item?.war_surcharge_disc || 0,
                                    ).toFixed(2),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {CommaSeparator(
                                    parseFloat(item?.invoice?.balance).toFixed(
                                      2,
                                    ),
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {(() => {
                                    const paid = parseFloat(
                                      item?.invoice?.paid || 0,
                                    );
                                    const total = parseFloat(
                                      item?.invoice?.total || 0,
                                    );
                                    const balance = parseFloat(
                                      item?.invoice?.balance || 0,
                                    );

                                    const isPaid =
                                      Math.abs(paid - total) <= 0.95;
                                    const isUnpaid =
                                      Math.abs(balance - total) <= 0.95;
                                    const isPartial = !isPaid && !isUnpaid;

                                    console.log(
                                      isUnpaid,
                                      isPaid,
                                      isPartial,
                                      "paid, unpaid, partial",
                                    );

                                    const statusIcon = isPaid ? (
                                      <CheckIcon />
                                    ) : isUnpaid ? (
                                      <PendingIcon />
                                    ) : (
                                      <CheckIcon />
                                    );
                                    const statusText = isPaid
                                      ? "Paid"
                                      : isUnpaid
                                        ? "UnPaid"
                                        : "Partial";

                                    const iconColor = isPaid
                                      ? Colors.primary
                                      : isUnpaid
                                        ? Colors.danger
                                        : Colors.bluishCyan;

                                    return (
                                      <Box
                                        sx={{
                                          path: { fill: iconColor },
                                        }}
                                      >
                                        <span className="pdf-hide">
                                          {statusIcon}
                                        </span>
                                        {statusText}
                                      </Box>
                                    );
                                  })()}
                                </Cell>

                                {/* <Cell className='pdf-table'>
                                  <Box
                                  // sx={{
                                  //   path: {
                                  //     fill: parseFloat(item?.invoice?.paid).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2) ?
                                  //       Colors.primary : parseFloat(item?.invoice?.balance).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2) ?
                                  //         Colors.danger : Colors.bluishCyan
                                  //     // item?.invoice?.paid !== item?.invoice?.total &&
                                  //     //   item?.invoice?.paid !== "0.000"
                                  //     //   ? Colors.bluishCyan
                                  //     //   : item?.invoice?.paid ==="0.000"
                                  //     //     ? Colors.danger
                                  //     //     : Colors.primary,
                                  //   },
                                  // }}
                                  >
                                    <Box
                                      sx={{
                                        path: {
                                          fill: Math.abs(parseFloat(item?.invoice?.paid) - parseFloat(item?.invoice?.total)) <= 0.95
                                            ? Colors.primary
                                            : parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2)
                                              ? Colors.danger
                                              : Colors.bluishCyan,
                                        },
                                      }}
                                    >
                                      <span className="pdf-hide">
                                        {Math.abs(parseFloat(item?.invoice?.paid) - parseFloat(item?.invoice?.total)) <= 0.95 ? (
                                          <CheckIcon />
                                        ) : parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2) ? (
                                          <PendingIcon />
                                        ) : (
                                          <CheckIcon />
                                        )}
                                      </span>
                                      {
                                        Math.abs(parseFloat(item?.invoice?.paid) - parseFloat(item?.invoice?.total)) <= 0.95
                                          ? "Paid"
                                          : parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2)
                                            ? "UnPaid"
                                            : "Partial"
                                      }
                                    </Box>

                                    {/* <span className="pdf-hide">
                                      {" "}
                                      {parseFloat(item?.invoice?.paid).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2) ? (
                                        <CheckIcon />
                                      ) : parseFloat(item?.invoice?.balance).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2) ? (
                                        <PendingIcon />
                                      ) : (
                                        <CheckIcon />
                                      )}
                                    </span>
                                    {
                                      parseFloat(item?.invoice?.paid).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2)
                                        ? "Paid"
                                        : parseFloat(item?.invoice?.balance).toFixed(2) == parseFloat(item?.invoice?.total).toFixed(2)
                                          ? "UnPaid"
                                          : "Partial"
                                    } */}
                                {/* {item?.invoice && item?.invoice?.paid == 0 ? (
                                    <Fragment>
                                      <Box component={'div'} className='pdf-hide'>
                                        <Box
                                          sx={{
                                            width: '25px',
                                            height: '25px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: `1px solid ${Colors.danger}`,
                                            borderRadius: '50%',
                                          }}
                                        >
                                          <span className='pdf-hide'>
                                            <Close
                                              sx={{
                                                fontSize: '18px',
                                                color: Colors.danger,
                                              }}
                                            />
                                          </span>
                                        </Box>
                                        Unpaid
                                      </Box>
                                      <Box
                                        component={'div'}
                                        className='pdf-show'
                                        sx={{ display: 'none !important' }}
                                      >
                                        Unpaid
                                      </Box>
                                    </Fragment>
                                  ) : item?.invoice &&
                                    item?.invoice?.paid > 0 &&
                                    item?.invoice?.paid < item?.invoice?.total ||
                                    item?.invoice &&
                                    item?.invoice?.paid > 0 &&
                                    item?.invoice?.paid < item?.total ? (

                                    <Fragment>
                                      <Box component={'div'} className='pdf-hide'>
                                        <Box
                                          sx={{
                                            width: '25px',
                                            height: '25px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '1px solid #25ABE1',
                                            borderRadius: '50%',
                                          }}
                                        >
                                          <span className='pdf-hide'>
                                            {' '}
                                            <Check
                                              sx={{
                                                fontSize: '18px',
                                                color: '#25ABE1',
                                              }}
                                            />
                                          </span>
                                        </Box>
                                        Partial
                                      </Box>
                                      <Box
                                        component={'div'}
                                        className='pdf-show'
                                        sx={{ display: 'none !important' }}
                                      >
                                        Partial
                                      </Box>
                                    </Fragment>
                                  ) : (
                                    <Fragment>
                                      <Box component={'div'} className='pdf-hide'>
                                        <Box
                                          sx={{
                                            width: '25px',
                                            height: '25px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: `1px solid ${Colors.primary}`,
                                            borderRadius: '50%',
                                          }}
                                        >
                                          <span className='pdf-hide'>
                                            {' '}
                                            <Check
                                              sx={{
                                                fontSize: '18px',
                                                color: '#25ABE1',
                                              }}
                                            />
                                          </span>
                                        </Box>
                                        Paid
                                      </Box>
                                      <Box
                                        component={'div'}
                                        className='pdf-show'
                                        sx={{ display: 'none !important' }}
                                      >
                                        Paid
                                      </Box>
                                    </Fragment>
                                  )} 
                              </Box>
                                </Cell> */}
                                <Cell>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {/* <Box
                                      onClick={() => {
                                        if (parseFloat(item?.invoice?.balance).toFixed(2) !== parseFloat(item?.invoice?.total).toFixed(2)) {
                                          setOpenDeleteModal(true);
                                          setSelectCostingId(item?.id);
                                        }
                                      }}
                                      sx={{ mr: '12px' }}
                                    >
                                      <IconButton
                                        sx={{
                                          bgcolor: parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2) ? Colors.grey : Colors.red,
                                          '&:hover': {
                                            bgcolor: parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2) ? Colors.grey : Colors.red,
                                          },
                                        }}
                                        disabled={parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2)}
                                      >
                                        <Delete />
                                      </IconButton>
                                      <Typography variant='body2' color={parseFloat(item?.invoice?.balance).toFixed(2) === parseFloat(item?.invoice?.total).toFixed(2) ? Colors.grey : 'inherit'}>
                                        Delete
                                      </Typography>
                                    </Box> */}
                                    {/* <Box
                                      component={"div"}
                                      className="pdf-hide"
                                      disabled={true}
                                      style={item?.is_reversed ? {
                                        opacity: 0.5,
                                        pointerEvents: 'none'
                                      } : {}}
                                      onClick={() => {
                                        setOpenReverseModal(true);
                                        setSelectedRefId(item.invoice.id);
                                        setSelectedDate(item.c_date);
                                      }
                                      }
                                    >
                                      <IconButton
                                        sx={{
                                          bgcolor: Colors.bluishCyan,
                                          "&:hover": {
                                            bgcolor: Colors.bluishCyan,
                                          },
                                        }}
                                      >
                                        <Edit
                                          sx={{
                                            color: Colors.white,
                                            height: "16px !important",
                                          }}
                                        />
                                      </IconButton>
                                      <Typography variant="body2">
                                        Reverse
                                      </Typography>
                                    </Box> */}
                                    {/* {item?.invoice && ( */}
                                    <Box
                                      component={"div"}
                                      className="pdf-hide"
                                      sx={{ gap: "16px !important" }}
                                    >
                                      <DropdownMenu
                                        item={item}
                                        permissions={permissions}
                                        navigate={navigate}
                                        ErrorToaster={ErrorToaster}
                                        Colors={Colors}
                                        isOpen={activeMenu === item.id}
                                        onToggle={(isOpen) =>
                                          handleMenuToggle(item.id, isOpen)
                                        }
                                        id={item?.id}
                                        voucher={true}
                                        client={true}
                                        v2={true}
                                        isAdmin={user?.user_type == "A"}
                                        onClickDeletepaidunpaidV2={() => {
                                          handleMenuToggle(false);
                                          setOpenDeleteModal(true);
                                          setSelectCostingId(item?.id);
                                        }}
                                        reverseVoucher={() => {
                                          handleMenuToggle(false);
                                          setOpenReverseModal(true);
                                          setSelectedRefId(item.invoice.id);
                                          setSelectedDate(item.c_date);
                                        }}
                                        voucherView={() => {
                                          handleMenuToggle(false);
                                          window.open(
                                            `/client-invoice-detail-v2/${item?.invoice?.id}`,
                                            "_blank" , 'noopener,noreferrer'
                                          );
                                        }}
                                        isForward={true}
                                        whatsAppItem={
                                          item?.invoice?.erp_invoices?.length >
                                          0
                                            ? item?.invoice
                                            : null
                                        }
                                        whatsAppClick={() => {
                                          handleMenuToggle(false);
                                          setOpenWhatsAppModal(true);
                                          setSelectedId({
                                            path: "client-invoice-preview",
                                            id: item?.invoice,
                                          });
                                        }}
                                        emailClick={() => {
                                          handleMenuToggle(false);
                                          setOpenEmailModal(true);
                                          setSelectedId({
                                            path: "client-invoice-preview",
                                            id: item?.invoice?.id,
                                          });
                                        }}
                                      />
                                      {/* <Box
                                        onClick={() =>
                                          window.open(
                                            `/client-invoice-detail/${item?.invoice?.id}`,
                                            '_blank'
                                          )
                                        }
                                      >
                                        <IconButton
                                          sx={{
                                            bgcolor: Colors.primary,
                                            '&:hover': {
                                              bgcolor: Colors.primary,
                                            },
                                          }}
                                        >
                                          <EyeIcon />
                                        </IconButton>
                                        <Typography variant='body2'>
                                          View
                                        </Typography>
                                      </Box>
                                      <Box
                                        component={'div'}
                                        className='pdf-hide'
                                        sx={{ gap: '12px !important' }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <IconButton
                                            sx={{
                                              bgcolor: Colors.primary,
                                              '&:hover': {
                                                bgcolor: Colors.primary,
                                              },
                                              p: '8px',
                                            }}
                                          >
                                            <WhatsAppIcon
                                              sx={{
                                                fontSize: '18px',
                                                color: '#FFFFFF',
                                              }}
                                              onClick={() => {
                                                setOpenWhatsAppModal(true);
                                                setSelectedId({
                                                  path: 'client-invoice-preview',
                                                  id: item?.invoice?.id,
                                                });
                                              }}
                                            />
                                          </IconButton>
                                          <Typography
                                            variant='body2'
                                            sx={{ fontSize: '12px' }}
                                          ></Typography>
                                        </Box>
                                        |
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <IconButton sx={{ p: '8px' }}>
                                            <EmailIcon
                                              sx={{
                                                fontSize: '18px',
                                                color: Colors.blue,
                                              }}
                                              onClick={() => {
                                                setOpenEmailModal(true);
                                                setSelectedId({
                                                  path: 'client-invoice-preview',
                                                  id: item?.invoice?.id,
                                                });
                                              }}
                                            />
                                          </IconButton>
                                          <Typography
                                            variant='body2'
                                            sx={{ fontSize: '12px' }}
                                          ></Typography>
                                        </Box>
                                      </Box> */}
                                    </Box>
                                    {/* )} */}
                                  </div>
                                </Cell>
                              </Row>
                            ))}
                          </Fragment>
                        </>
                      ) : (
                        <Row>
                          <Cell
                            colSpan={tableHead.length + 1}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            No Data Found
                          </Cell>
                        </Row>
                      )
                    ) : (
                      <Row>
                        <Cell
                          colSpan={tableHead.length + 2}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          <Box className={classes.loaderWrap}>
                            <CircularProgress />
                          </Box>
                        </Cell>
                      </Row>
                    )}

                    {/* Render ForwardToWhatsAppModal */}
                    <WhatsAppModal
                      open={openWhatsAppModal}
                      onClose={handleCloseWhatsAppModal}
                      id={selectedId}
                      file={selectedId?.id?.erp_invoices?.[0]?.file_key}
                    />
                    {/* Render ForwardToEmail */}
                    <EmailModal
                      open={openEmailModal}
                      onClose={handleCloseEmailModal}
                      id={selectedId}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </PDFExport>
            <Grid item md={12} mb={3}>
              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) => getInvoices(1, size.target.value)}
                tableCount={invoices?.length}
                totalCount={totalCount}
                onPageChange={(page) => getInvoices(page, "")}
              />
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default UnpaidPaidInvoicesV2;
